import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { ScreenHeader, Surface, Button, Divider, FeedbackMsg, inputCss } from '../components/ui';
import { useConfig } from '../context/ConfigContext';

const API_URL = process.env.REACT_APP_API_URL;

const ACCENT_PRESETS = [
  { label: 'Roxo (padrão)', value: '' },
  { label: 'Azul', value: '#2563eb' },
  { label: 'Verde', value: '#16a34a' },
  { label: 'Rosa', value: '#db2777' },
  { label: 'Laranja', value: '#ea580c' },
  { label: 'Teal', value: '#0d9488' },
];

export default function Configuracoes() {
  const { config, carregar } = useConfig();
  const [form, setForm] = useState({ nome_sistema: '', cor_accent: '', contato_telefone: '', contato_email: '', contato_endereco: '' });
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [msg, setMsg] = useState('');
  const logoRef = useRef();

  useEffect(() => {
    setForm({
      nome_sistema: config.nome_sistema || '',
      cor_accent: config.cor_accent || '',
      contato_telefone: config.contato_telefone || '',
      contato_email: config.contato_email || '',
      contato_endereco: config.contato_endereco || '',
    });
  }, [config]);

  function upd(k, v) { setForm(f => ({ ...f, [k]: v })); }

  function feedback(m) {
    setMsg(m);
    setTimeout(() => setMsg(''), 3500);
  }

  function handleSave(e) {
    e.preventDefault();
    setSaving(true);
    axios.put(`${API_URL}/configuracoes`, form, { withCredentials: true })
      .then(() => { carregar(); feedback('Configurações salvas com sucesso!'); })
      .catch(err => feedback(err.response?.data?.erro || 'Erro ao salvar.'))
      .finally(() => setSaving(false));
  }

  function handleLogo(e) {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append('logo', file);
    axios.post(`${API_URL}/configuracoes/logo`, fd, { headers: { 'Content-Type': 'multipart/form-data' }, withCredentials: true })
      .then(() => { carregar(); feedback('Logo atualizado!'); })
      .catch(err => feedback(err.response?.data?.erro || 'Erro ao enviar logo.'))
      .finally(() => setUploading(false));
  }

  const section = (title) => (
    <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: 0.5, textTransform: 'uppercase', color: 'var(--text-tertiary)', margin: '0 0 var(--gap-2)' }}>
      {title}
    </div>
  );

  return (
    <div className="mema-screen" style={{ display: 'flex', flexDirection: 'column', gap: 'var(--gap-3)', paddingBottom: 90 }}>
      <ScreenHeader title="Configurações"/>

      <form onSubmit={handleSave} style={{ display: 'flex', flexDirection: 'column', gap: 'var(--gap-3)', padding: '0 var(--gap-3)' }}>

        {/* Identity */}
        {section('Identidade')}
        <Surface style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
          {/* Logo */}
          <div style={{ padding: 'var(--pad-card)', display: 'flex', alignItems: 'center', gap: 'var(--gap-3)' }}>
            <div style={{ flexShrink: 0 }}>
              {config.logo_url
                ? <img src={config.logo_url} alt="Logo" style={{ width: 56, height: 56, borderRadius: 'var(--radius-md)', objectFit: 'contain', background: 'var(--bg-sunken)', padding: 4 }}/>
                : <div style={{ width: 56, height: 56, borderRadius: 'var(--radius-md)', background: 'var(--bg-sunken)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>🏫</div>
              }
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 13, fontWeight: 540, color: 'var(--text-primary)', marginBottom: 4 }}>Logo do sistema</div>
              <div style={{ fontSize: 12, color: 'var(--text-tertiary)', marginBottom: 8 }}>PNG, JPG ou SVG. Recomendado: 200×200 px.</div>
              <Button type="button" size="sm" variant="secondary" disabled={uploading} onClick={() => logoRef.current.click()}>
                {uploading ? 'Enviando…' : 'Trocar logo'}
              </Button>
              <input ref={logoRef} type="file" accept=".png,.jpg,.jpeg,.svg,.webp" onChange={handleLogo} style={{ display: 'none' }}/>
            </div>
          </div>
          <Divider/>
          <div style={{ padding: 'var(--pad-card)', display: 'flex', flexDirection: 'column', gap: 5 }}>
            <label style={{ fontSize: 12, fontWeight: 540, color: 'var(--text-secondary)' }}>Nome do sistema</label>
            <input type="text" value={form.nome_sistema} placeholder="Aulas da Mema"
              onChange={e => upd('nome_sistema', e.target.value)} style={inputCss}/>
          </div>
        </Surface>

        {/* Accent color */}
        {section('Cor de destaque')}
        <Surface style={{ padding: 'var(--pad-card)', display: 'flex', flexDirection: 'column', gap: 'var(--gap-2)' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {ACCENT_PRESETS.map(p => {
              const selected = form.cor_accent === p.value;
              return (
                <button key={p.value} type="button" onClick={() => upd('cor_accent', p.value)} style={{
                  display: 'flex', alignItems: 'center', gap: 7,
                  height: 34, padding: '0 12px', borderRadius: 'var(--radius-md)',
                  border: selected ? '2px solid var(--accent)' : '1px solid var(--border-default)',
                  background: selected ? 'var(--accent-soft)' : 'var(--bg-surface)',
                  color: 'var(--text-primary)', fontSize: 12.5, fontWeight: selected ? 600 : 400,
                  cursor: 'pointer', fontFamily: 'inherit', transition: 'all .12s',
                }}>
                  <span style={{
                    width: 14, height: 14, borderRadius: '50%', flexShrink: 0,
                    background: p.value || 'oklch(52% 0.22 300)',
                    border: '1px solid rgba(0,0,0,0.1)',
                  }}/>
                  {p.label}
                </button>
              );
            })}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 }}>
            <label style={{ fontSize: 12, color: 'var(--text-secondary)', fontWeight: 540 }}>Cor personalizada:</label>
            <input type="color" value={form.cor_accent || '#7c3aed'}
              onChange={e => upd('cor_accent', e.target.value)}
              style={{ width: 36, height: 36, border: '1px solid var(--border-default)', borderRadius: 'var(--radius-md)', padding: 2, background: 'var(--bg-sunken)', cursor: 'pointer' }}/>
            {form.cor_accent && (
              <button type="button" onClick={() => upd('cor_accent', '')}
                style={{ fontSize: 12, color: 'var(--text-tertiary)', background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'inherit' }}>
                Resetar padrão
              </button>
            )}
          </div>
        </Surface>

        {/* Contact */}
        {section('Informações de contato')}
        <Surface style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
          {[
            { label: 'Telefone', name: 'contato_telefone', type: 'tel', placeholder: '(00) 00000-0000' },
            { label: 'E-mail', name: 'contato_email', type: 'email', placeholder: 'contato@escola.com' },
            { label: 'Endereço', name: 'contato_endereco', type: 'text', placeholder: 'Rua…' },
          ].map((f, i) => (
            <React.Fragment key={f.name}>
              {i > 0 && <Divider/>}
              <div style={{ padding: 'var(--pad-card)', display: 'flex', flexDirection: 'column', gap: 5 }}>
                <label style={{ fontSize: 12, fontWeight: 540, color: 'var(--text-secondary)' }}>{f.label}</label>
                <input type={f.type} value={form[f.name]} placeholder={f.placeholder}
                  onChange={e => upd(f.name, e.target.value)} style={inputCss}/>
              </div>
            </React.Fragment>
          ))}
        </Surface>

        {msg && <FeedbackMsg msg={msg}/>}

        <Button variant="primary" size="lg" disabled={saving} style={{ width: '100%' }}>
          {saving ? 'Salvando…' : 'Salvar configurações'}
        </Button>
      </form>
    </div>
  );
}
